import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

/** @class CarouselNavControlsMixin */
/** @method */
export var CarouselNavControlsMixin = function CarouselNavControlsMixin(props) {
  return token('CarouselNavControls.gridColumnGap', function (gridColumnGap) {
    return css(["display:grid;grid-auto-flow:column;grid-column-gap:", ";align-items:start;"], gridColumnGap ? gridColumnGap + "px" : spaceMixin('sm')(props));
  })(props);
};